import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


export default new Vuex.Store({
    strict: true,
    state: {
      baseUrl: '/api',
      isLoading: false,
      restaurantData: '',
      restaurantWebConfig: '',
      allRestaurants: [],
    },
    getters: {},
    mutations: {
      updateCurrentRestaurant(state, data) {
        state.restaurantId = data.id
        state.restaurantName = data.name
      },
      setAllRestaurants(state, data) {
        state.allRestaurants = data
      },
      setRestaurantWebConfig(state, data) {
        state.restaurantWebConfig = data
      },
      setRestaurantData(state, data) {
        state.restaurantData = data
      }
    },
    actions: {
      setCurrentRestaurant({state, commit}, {id, name}) {
        state.commit('updateCurrentRestaurant', data)
      }
    }
})
